function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_1347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4375 27.75H11.9604C10.1828 27.7495 8.46386 27.114 7.11352 25.9579C6.39795 25.3454 5.82359 24.5852 5.42996 23.7295C5.03633 22.8738 4.83277 21.9429 4.83331 21.001V18.7632C4.83331 17.4066 5.38331 16.0774 6.34352 15.1172L8.27081 13.1899V2.54167C8.27081 1.27781 9.29863 0.25 10.5625 0.25C11.8263 0.25 12.8541 1.27781 12.8541 2.54167V10.0652L12.9676 9.98958C13.5304 9.62284 14.1876 9.42759 14.8594 9.42759C15.5311 9.42759 16.1883 9.62284 16.7511 9.98958L18.5833 11.2099V5.97917C18.5833 4.71531 19.6111 3.6875 20.875 3.6875C22.1388 3.6875 23.1666 4.71531 23.1666 5.97917V22.0208C23.1666 25.1799 20.5965 27.75 17.4375 27.75Z",
    fill: "#987DD4",
    style: {
      fill: "#987DD4",
      fill: "color(display-p3 0.5944 0.4889 0.8309)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.27085 14.8114L7.15367 15.9275C6.40434 16.6814 5.98236 17.7004 5.97919 18.7634V21.0012C5.97919 22.5733 6.6644 24.0629 7.85835 25.0872C9.00119 26.0657 10.456 26.6037 11.9604 26.6043H17.4375C19.9652 26.6043 22.0209 24.5487 22.0209 22.021V5.97933C22.0209 5.67543 21.9001 5.38399 21.6852 5.1691C21.4704 4.95422 21.1789 4.8335 20.875 4.8335C20.5711 4.8335 20.2797 4.95422 20.0648 5.1691C19.8499 5.38399 19.7292 5.67543 19.7292 5.97933V12.2046C19.7446 12.3144 19.7279 12.4262 19.6811 12.5266C19.6343 12.627 19.5593 12.7117 19.4653 12.7704C19.3714 12.8291 19.2624 12.8593 19.1516 12.8573C19.0408 12.8553 18.933 12.8212 18.8412 12.7592L16.1164 10.9431C15.7425 10.6992 15.3058 10.5694 14.8594 10.5694C14.413 10.5694 13.9763 10.6992 13.6024 10.9431L12.5987 11.6122C12.5124 11.6697 12.4122 11.7026 12.3086 11.7075C12.2051 11.7125 12.1022 11.6893 12.0109 11.6404C11.9195 11.5914 11.8431 11.5187 11.7898 11.4298C11.7366 11.3409 11.7084 11.2392 11.7084 11.1356V2.54183C11.7084 2.23794 11.5876 1.94649 11.3727 1.7316C11.1579 1.51672 10.8664 1.396 10.5625 1.396C10.2586 1.396 9.96718 1.51672 9.75229 1.7316C9.53741 1.94649 9.41669 2.23794 9.41669 2.54183V18.0106C9.41669 18.1625 9.35633 18.3082 9.24888 18.4157C9.14144 18.5231 8.99572 18.5835 8.84377 18.5835C8.69182 18.5835 8.5461 18.5231 8.43866 18.4157C8.33121 18.3082 8.27085 18.1625 8.27085 18.0106V14.8114Z",
    fill: "#C5AAFF",
    style: {
      fill: "#C5AAFF",
      fill: "color(display-p3 0.7725 0.6667 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.1,
    d: "M7.69789 15.3844V18.0106C7.69789 18.1626 7.75825 18.3083 7.8657 18.4157C7.97314 18.5232 8.11886 18.5835 8.27081 18.5835C8.37256 18.5809 8.47164 18.5504 8.55727 18.4953C8.47131 18.4466 8.39962 18.3763 8.34935 18.2912C8.29909 18.2062 8.27201 18.1094 8.27081 18.0106V14.8115L7.69789 15.3844ZM21.3425 4.93896C21.4106 5.08547 21.4466 5.24489 21.4479 5.40646V21.4481C21.4479 23.9758 19.3923 26.0315 16.8646 26.0315H11.3875C9.9286 26.0279 8.51612 25.5184 7.39081 24.59C7.5432 24.7596 7.683 24.9372 7.85831 25.0873C9.00114 26.0658 10.4559 26.6038 11.9604 26.6044H17.4375C19.9652 26.6044 22.0208 24.5488 22.0208 22.021V5.97938C22.02 5.75904 21.9555 5.54363 21.8352 5.35906C21.7149 5.17448 21.5438 5.0286 21.3425 4.93896Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4375 27.75H11.9604C10.1828 27.7495 8.46386 27.114 7.11352 25.9579C6.39795 25.3454 5.82359 24.5852 5.42996 23.7295C5.03633 22.8738 4.83277 21.9429 4.83331 21.001V18.7632C4.83331 17.4066 5.38331 16.0774 6.34352 15.1172L8.27081 13.1899V2.54167C8.27081 1.27781 9.29863 0.25 10.5625 0.25C11.8263 0.25 12.8541 1.27781 12.8541 2.54167V10.0652L12.9676 9.98958C13.5304 9.62284 14.1876 9.42759 14.8594 9.42759C15.5311 9.42759 16.1883 9.62284 16.7511 9.98958L18.5833 11.2099V5.97917C18.5833 4.71531 19.6111 3.6875 20.875 3.6875C22.1388 3.6875 23.1666 4.71531 23.1666 5.97917V22.0208C23.1666 25.1799 20.5965 27.75 17.4375 27.75Z",
    fill: "url(#paint0_linear_629_1347)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_629_1347",
    x1: 4.38186,
    y1: 10.3734,
    x2: 24.7594,
    y2: 19.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E4FF",
    stopOpacity: 0.2,
    style: {
      stopColor: "#F0E4FF",
      stopColor: "color(display-p3 0.9412 0.8941 1.0000)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E4FF",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaring);
export default __webpack_public_path__ + "static/media/daring.26cd0ce5a16f671685324cc2be71536c.svg";
export { ForwardRef as ReactComponent };